// frontend/src/site/builder/sections/CtaFinalForm.jsx
import React from 'react';

export default function CtaFinalForm({ value = {}, onChange }) {
  const {
    titulo = '',
    descricao = '',
    textoBotao = '',
    tipoAcao = 'whatsapp', // whatsapp | link
    link = '',
  } = value;

  function update(patch) {
    if (typeof onChange === 'function') {
      onChange(patch);
    }
  }

  return (
    <div className="space-y-4">
      {/* Título */}
      <div>
        <label className="text-sm font-medium text-gray-800">
          Título da Chamada
        </label>
        <input
          value={titulo}
          onChange={(e) => update({ titulo: e.target.value })}
          placeholder="Ex: Vamos encontrar o imóvel ideal para você"
          className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200"
        />
      </div>

      {/* Descrição */}
      <div>
        <label className="text-sm font-medium text-gray-800">
          Texto de apoio
        </label>
        <textarea
          value={descricao}
          onChange={(e) => update({ descricao: e.target.value })}
          placeholder="Ex: Fale comigo agora e receba um atendimento direto, seguro e estratégico."
          className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 min-h-[90px]"
        />
      </div>

      {/* Texto do botão */}
      <div>
        <label className="text-sm font-medium text-gray-800">
          Texto do botão
        </label>
        <input
          value={textoBotao}
          onChange={(e) => update({ textoBotao: e.target.value })}
          placeholder="Ex: Falar no WhatsApp"
          className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200"
        />
      </div>

      {/* Tipo de ação */}
      <div>
        <label className="text-sm font-medium text-gray-800">
          Ação do botão
        </label>
        <select
          value={tipoAcao}
          onChange={(e) => update({ tipoAcao: e.target.value })}
          className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200"
        >
          <option value="whatsapp">Abrir WhatsApp</option>
          <option value="link">Abrir link</option>
        </select>
      </div>

      {/* Link (condicional) */}
      {tipoAcao === 'link' && (
        <div>
          <label className="text-sm font-medium text-gray-800">
            Link do botão
          </label>
          <input
            value={link}
            onChange={(e) => update({ link: e.target.value })}
            placeholder="https://exemplo.com/contato"
            className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200"
          />
        </div>
      )}

      {/* Ajuda */}
      <div className="text-xs text-gray-500">
        💡 Se escolher WhatsApp, o botão usará automaticamente o número
        configurado no perfil do corretor.
      </div>
    </div>
  );
}
